import styled from '@emotion/styled'

import { colors, typo } from '~/@common/styles'
import { mediaQuery } from '~/@common/styles/mediaQuery'

export const S = {
  Wrapper: styled.div`
    overflow: auto;
  `,
  Profile: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 384px;
    margin: 0 auto;

    ${mediaQuery.underTablet} {
      width: 100%;
      margin-top: 10px;
    }

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid var(--Colors-Gray-300);
      padding-bottom: 16px;

      &[data-no-divider='true'] {
        border-bottom: none;
        padding-bottom: 0;
      }

      .switch-wrapper {
        display: flex;
        align-items: center;

        > p {
          ${typo.caption01}
          color: var(--Colors-Gray-900);
        }
      }
    }

    .profile-box {
      background-color: ${colors.white};
      border-radius: var(--Radius-300);
      overflow: hidden;
    }
    .profile-content {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 20px 30px;
    }
    .name {
      color: var(--Colors-Gray-900);
      font-weight: 700;
      min-height: 24px;
      ${typo.body01}
    }
    .info {
      display: flex;
      gap: 12px;
    }
    .info-label {
      display: flex;
      flex-direction: column;
      gap: 12px;
      color: var(--Colors-Gray-700);
      ${typo.body02}
    }
    .info-value {
      display: flex;
      flex-direction: column;
      gap: 12px;
      color: var(--Colors-Gray-900);
      ${typo.body02}
      > p {
        min-height: 21px;
      }
    }
    .button-container {
      display: flex;
      border-top: 1px solid var(--Colors-Gray-200);

      button:first-of-type {
        border-right: 1px solid var(--Colors-Gray-200);
      }
    }
    .password-change {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 16px 0;
      flex: 1;
      gap: 2px;

      &:active {
        background-color: var(--Colors-Gray-100);
      }
      p {
        text-align: center;
        ${typo.caption01};
      }
    }
  `,
  Etc: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 384px;
    margin: 0 auto;
    gap: 10px;
    margin-top: 10px;
    ${mediaQuery.underTablet} {
      width: 100%;
    }

    .notification-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 16px 30px;
      background-color: white;
      border-radius: var(--Radius-300);
    }

    .notification-content {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .notification-title {
      ${typo.body02}
      color: var(--Colors-Gray-800);
      font-weight: 700;
    }

    .notification-description {
      ${typo.caption01}
      color: var(--Colors-Gray-600);
    }

    .etc-card {
      display: flex;
      align-items: center;
      background-color: white;
      padding: 0 30px;
      width: 100%;
      border-radius: var(--Radius-300);
      height: 45px;
      cursor: pointer;

      &:active {
        background-color: var(--Colors-Gray-100);
      }
      > p {
        margin-left: 4px;
        margin-right: auto;
      }
    }
  `,
}
